import { render, staticRenderFns } from "./time_limit.vue?vue&type=template&id=56e7e440&scoped=true&lang=pug&"
import script from "./time_limit.vue?vue&type=script&lang=js&"
export * from "./time_limit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e7e440",
  null
  
)

export default component.exports